import { useEffect, MouseEvent, KeyboardEvent, RefObject } from 'react'

export function useClickOutside(
  ref: RefObject<HTMLElement>,
  handler: (e: MouseEvent | KeyboardEvent) => void
) {
  useEffect(() => {
    const handleDocumentClick = (e: any) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        handler(e)
      }
    }

    document.addEventListener('mousedown', handleDocumentClick)
    document.addEventListener('touchstart', handleDocumentClick)

    return () => {
      document.removeEventListener('mousedown', handleDocumentClick)
      document.removeEventListener('touchstart', handleDocumentClick)
    }
  }, [ref, handler])
}
